export default __webpack_public_path__ + "static/media/king-arthur.1c4a6c94.png";